<!--
 * www.cloudscope.cn
 * Copyright (c) 2019. All Rights Reserved.
-->
<!--
 * @Author: liuchang
 * @Date: 2019-08-14 20:27:01
 * @Description: 角色管理
 -->
<template>
    <div class="con-f-div">
        <div class="top">
            <el-header class="top-header">
                <div class="header-content">
                    <h3 class="header-content-title">角色管理查询</h3>
                    <el-button class="header-content-btn" @click="shiftFormShow">
                        <icon name="double-arrow-up" class="svg-icon-btn" v-show="formShow"></icon>
                        <icon name="double-arrow-down" class="svg-icon-btn" v-show="!formShow"></icon>
                    </el-button>
                </div>
            </el-header>
            <div class="top-content" v-show="formShow">
                <el-form
                    ref="form"
                    label-position="left"
                    :model="form"
                    label-width="80px"
                    :inline="true"
                >
                    <el-form-item label="名称" prop="name">
                        <el-input v-model="form.name" placeholder="输入名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="编码" prop="code">
                        <el-input v-model="form.code" placeholder="输入编码" clearable></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="top-footer">
                <div class="left-btn">
                    <el-button type="primary" size="small" @click="showDialog()">新增</el-button>
                </div>
                <div class="right-btn">
                    <el-button type="primary" size="small" class="reset-btn" @click="resetForm">重置</el-button>
                    <el-button
                        type="primary"
                        size="small"
                        style="width:70px"
                        @click="loadlist(1)"
                    >查询</el-button>
                </div>
            </div>
        </div>
        <div class="list tab-drive">
            <List @showDialog="showDialog" @loadlist="loadlist" :title="tableTitle" ref="RoleList"></List>
        </div>
        <Add
            @hideDialog="hideDialog"
            @loadTable="loadTable"
            @loadTableRefresh="loadTableRefresh"
            v-show="isShow"
            ref="addRole"
            :addTitle="addTitle"
        ></Add>
    </div>
</template>
<script>
import List from '@/components/RoleManagement/List';
import Add from '@/components/RoleManagement/Add';
export default {
    name: 'RoleManagement',
    components: {
        List,
        Add
    },
    data () {
        return {
            form: {
                name: '',
                code: ''
            },
            tableTitle: '角色管理列表',
            isShow: false,
            addTitle: '添加角色',
            selectLoading: global.loading,
            formShow: true // 查询区域显示
        };
    },
    mounted () {},
    methods: {
        /**
         * @author: liuc
         * @description: 隐藏弹窗
         * @param {}
         */
        hideDialog () {
            this.isShow = false;
        },
        /**
         * @author: liuc
         * @description:显示新增弹窗或编辑弹窗
         * @param {id} 判断弹窗类型
         */
        showDialog (id) {
            this.isShow = true;
            var type = 0;
            if (id) {
                this.addTitle = '编辑角色';
                type = 1;
            } else {
                this.addTitle = '新增角色';
            }
            this.$refs.addRole.open(type, id);
        },
        /**
         * @author: liuc
         * @description: 获取表格数据
         * @param {queryBean}: 请求接口数据
         */
        loadTable (queryBean) {
            this.$refs.RoleList.loadTable(queryBean);
        },
        /**
         * @author: liuc
         * @description:新增、编辑角色后，刷新列表
         * @param {}
         */
        loadTableRefresh () {
            this.$refs.RoleList.loadTableRefresh();
        },
        /**
         * @author: liuc
         * @description:重置
         * @param {}
         */
        resetForm () {
            this.$refs.form.resetFields();
            this.loadlist(1);
        },
        /**
         * @author: liuc
         * @description: 查询角色
         * @param {currentPage} 当前页数
         */
        loadlist (currentPage) {
            global.loading.select = true;
            let filters = [];
            let name = this.tableSearchNode(
                'name',
                'like',
                [this.form.name],
                'String'
            );
            let code = this.tableSearchNode(
                'code',
                'like',
                [this.form.code],
                'String'
            );
            filters.push([name]);
            filters.push([code]);
            let queryBean = this.buildQueryBean(
                currentPage,
                this.pageSize,
                filters
            );
            this.loadTable(queryBean);
        },
        /**
         * @author: liuc
         * @description: 角色管理查询表单显示隐藏
         * @param {}
         */
        shiftFormShow () {
            if (this.formShow) {
                this.formShow = false;
            } else {
                this.formShow = true;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.el-header {
    font-size: 24px;
}
.con-f-div {
    box-sizing: border-box;
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .top {
        border: 1px solid #e1e8e9;
        margin-right: 29px;
        .top-header {
            display: flex;
            align-items: center;
            height: 70px;
            padding-left: 29px;
            background: #f4f7fb;
            .header-content {
                flex: 1;
                display: flex;
                align-items: center;
                .header-content-title {
                    font-size: 24px;
                    font-weight: 400;
                    color: #333;
                }
            }
        }
        .top-content {
            width: 80%;
            padding-top: 20px;
            padding-left: 29px;
            .el-form-item {
                margin-bottom: 10px;
                /deep/ .el-input {
                    width: 320px;
                }
            }
        }
        .top-footer {
            border-top: 1px solid #e1e8e9;
            padding: 10px 20px;
            overflow: hidden;
            .left-btn {
                float: left;
            }
            .right-btn {
                float: right;
                .reset-btn {
                    background: #fff;
                    color: #4970ad;
                }
            }
        }
    }
    .list {
        flex: 1;
        overflow: hidden;
    }
}
</style>



// WEBPACK FOOTER //
// ./src/views/RoleManagement.vue